import { render } from "./googleLoginBtn.vue?vue&type=template&id=4c291add"
import script from "./googleLoginBtn.vue?vue&type=script&lang=js"
export * from "./googleLoginBtn.vue?vue&type=script&lang=js"

import exportComponent from "/Users/juvicmartires/Documents/BreakingHits/breakinghits-vuejs-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__